module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/blog-category.json
// module id = 1459
// module chunks = 21292905163581